import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "activerecord": {
    "attributes": {
      "data_entity": {
        "keys": {
          "address": "Address",
          "address_state": "State/Province",
          "appointments": "Appointment",
          "assigned_manager_id": "Assigned Recruiter",
          "attachments": "Attachment",
          "campaign_id": "Campaign",
          "completion_date": "Completed At",
          "country_short_code": "Country",
          "created_at": "Date added",
          "education": "Education",
          "email": "Email",
          "first_name": "First Name",
          "gender": "Gender",
          "geolocation": "Geolocation",
          "graduation_year": "Graduation Year",
          "labels": "Labels",
          "last_assigned_at": "Last Assigned Date",
          "last_interaction": "Last Interaction",
          "last_name": "Last Name",
          "location": "City/Municipality",
          "scheduled_at": "Scheduled At",
          "school_name": "School Name",
          "source": "Source",
          "talkscore_active_listening": "TalkScore Active Listening",
          "talkscore_answer_count": "TalkScore Answer Count",
          "talkscore_cefr": "TalkScore CEFR",
          "talkscore_comprehension": "TalkScore Comprehension / Spoken English Understanding",
          "talkscore_fluency": "TalkScore Fluency",
          "talkscore_generated_at": "Talkscore Generated at",
          "talkscore_grammar": "TalkScore Grammar",
          "talkscore_overall": "TalkScore Overall",
          "talkscore_pronunciation": "TalkScore Pronunciation",
          "talkscore_question_count": "TalkScore Question Count",
          "talkscore_scored_count": "TalkScore Scored Count",
          "talkscore_vocab": "TalkScore Vocabulary",
          "user_country_code": "Phone Country Code",
          "user_phone_number": "Mobile",
          "years_of_exp": "Years of Working Experience"
        }
      },
      "document/tag": {
        "permission": {
          "assigned_manager": "Onboarding Admin Access",
          "owner": "Owner Admin Access",
          "public": "Full Access"
        }
      },
      "smart_call/setting": {
        "scenario": {
          "custom_calls": "Custom Calls",
          "document_request": "Document Request",
          "engagement_calls_for_passive_candidates": "Engagement Calls for Passive Candidates",
          "feedback_collection": "Feedback Collection",
          "interview": "Interview",
          "job_fair_and_event_invitation": "Job Fair and Event Invitation",
          "offer_extension": "Offer Extension",
          "on_site_interview_invitation": "On Site Interview Invitation",
          "onboarding_information": "Onboarding Information",
          "rejection_notification": "Rejection Notification",
          "reminder": "Reminder",
          "status_update": "Status Update"
        }
      }
    },
    "models": {
      "candidate/attribute": "Candidate Attribute",
      "prompt/set": "Question Set",
      "workflow": "Autoflow"
    }
  },
  "autoflow": {
    "add": "Add",
    "edit": "Edit",
    "next": "Next",
    "operations": {
      "status": {
        "started": "Started"
      }
    },
    "operators": {
      "or": "OR"
    },
    "status": {
      "title": "Status"
    }
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "campaign_types": {
        "all": "All Campaigns"
      },
      "contract_type": {
        "options": {
          "internship": "Internship",
          "permanent": "Permanent",
          "temporary": "Temporary"
        },
        "title": "Contract Type"
      },
      "form": {
        "exit_interview": "Exit Interview",
        "inquiry": "Inquiry",
        "job_application": "Job Application",
        "job_template": "Job Template",
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "onboarding": "Onboarding",
        "salary": "Salary",
        "single_engagement": "Single Engagment",
        "type": "Campaign Type"
      },
      "job_category": {
        "options": {
          "accounting_auditing": "Accounting/Auditing",
          "administrative": "Administrative",
          "aerospace_engineering": "Aerospace Engineering",
          "architecture": "Architecture",
          "aviation": "Aviation",
          "building_supplies_retail": "Building supplies retail",
          "cleaning": "Cleaning",
          "coaching": "Coaching",
          "consultancy": "Consultancy",
          "creative": "Creative",
          "customer_service": "Customer Service",
          "design": "Design",
          "driving_transport": "Driving/Transport",
          "education": "Education",
          "engineering": "Engineering",
          "finance": "Finance",
          "food_kitchen": "Food/Kitchen",
          "healthcare": "Healthcare",
          "human_resources": "Human Resources",
          "insurance": "Insurance",
          "it": "IT",
          "journalism": "Journalism",
          "legal": "Legal",
          "management": "Management",
          "marketing": "Marketing",
          "operations": "Operations",
          "planning_logistics": "Planning/Logistics",
          "politics_policies": "Politics & Policies",
          "pr_communications": "PR/Communications",
          "procurement": "Procurement",
          "property": "Property",
          "quality_management": "Quality Management",
          "recruitment": "Recruitment",
          "retail": "Retail",
          "sales": "Sales",
          "science_and_research": "Science and Research",
          "skilled_work": "Skilled Work",
          "social_work": "Social Work",
          "technology": "Technology",
          "translations": "Translations",
          "urban_planning": "Urban Planning"
        },
        "title": "Job Function"
      },
      "job_industry": {
        "options": {
          "academic": "Academic",
          "accounting": "Accounting",
          "advertising": "Advertising",
          "aerospace": "Aerospace",
          "agriculture": "Agriculture",
          "arts_and_culture": "Arts & Culture",
          "automotive": "Automotive",
          "aviation": "Aviation",
          "banking": "Banking",
          "building_and_construction": "Building and Construction",
          "charity_and_not_for_profit": "Charity and Not for Profit",
          "chemical": "Chemical",
          "communications": "Communications",
          "defence_and_military": "Defence & Military",
          "e_commerce": "E-commerce",
          "education": "Education",
          "energy": "Energy",
          "engineering": "Engineering",
          "entertainment": "Entertainment",
          "facility_management": "Facility Management",
          "fashion": "Fashion",
          "fast_moving_consumer_goods": "Fast Moving Consumer Goods",
          "finance": "Finance",
          "food": "Food",
          "generic": "Generic",
          "government_and_public_sector": "Government and Public Sector",
          "health_and_safety": "Health and Safety",
          "healthcare": "Healthcare",
          "hospitality": "Hospitality",
          "information_technology": "Information Technology",
          "insurance": "Insurance",
          "language": "Language",
          "legal": "Legal",
          "leisure_and_sport": "Leisure and Sport",
          "logistics_and_supply_chain": "Logistics & Supply Chain",
          "manufacturing": "Manufacturing",
          "maritime": "Maritime",
          "media": "Media",
          "mining": "Mining",
          "multilingual": "Multilingual",
          "pharmaceuticals": "Pharmaceuticals",
          "property_and_housing": "Property and Housing",
          "real_estate": "Real Estate",
          "recruitment": "Recruitment",
          "retail": "Retail",
          "science_and_research": "Science & Research",
          "sustainability": "Sustainability",
          "telecommunications": "Telecommunications",
          "transport_and_rail": "Transport and Rail",
          "travel_and_tourism": "Travel and Tourism"
        },
        "title": "Job Industry"
      },
      "new_applications_status": {
        "closed": "Not Receiving New Applications",
        "receiving": "Receiving New Applications"
      }
    },
    "folders": {
      "all": "All Folders",
      "completed": {
        "title": "Completed"
      },
      "hired": {
        "title": "Hired"
      },
      "no_response": {
        "title": "No Response"
      },
      "on_hold": {
        "title": "On Hold"
      },
      "pending": {
        "title": "Inbox"
      },
      "rejected": {
        "title": "Rejected"
      },
      "shortlisted": {
        "title": "Shortlisted"
      }
    },
    "message": {
      "tabs": {
        "completion": {
          "form": {
            "preview": "Preview"
          }
        }
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      },
      "state": {
        "pending": "Queued"
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "filters": {
      "location": "Location",
      "search_campaigns": "Search campaigns"
    },
    "labels": {
      "completed": "Completed"
    },
    "menu": {
      "copy": "Copy"
    },
    "modals": {
      "confirm_your_action": "Confirm your action",
      "continue": "Continue"
    },
    "notice": {
      "candidate": {
        "one": "candidate",
        "other": "candidates"
      }
    },
    "options": {
      "deleted": "Deleted",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "toastr": {
      "actions": {
        "background": "This action is being processed in the background.",
        "failed": "This action was not successfully processed.",
        "success": "This action was processed successfully."
      }
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "buttons": {
        "delete": "Delete"
      },
      "folder_settings": {
        "destroy": {
          "confirm": "You are about to delete %{folder}. After deleting, it will no longer be visible in the campaigns. Do you wish to proceed?",
          "success": "The folder was deleted successfully"
        }
      },
      "team": {
        "email_address_label": "Email Address",
        "phone_number_label": "Phone Number",
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Add",
          "candidate_attribute": "Candidate Attribute",
          "description": "Select Candidate Attributes and assign a weight percentage to each one for a total ot 100% for the Applicant Score or this Campaign.",
          "dropdown_hint": "Select an Attribute from the list",
          "title": "Job Matching",
          "weight": "Weight"
        },
        "description": "Configure a Scoring System for this Campaign by assigning a weight to a Candidate Attribute (Geolocation, TalkScore English Proficiency and Multiple Choice Questions) and then setting up the scores for each item.",
        "error": "Job Matching was not saved. Please try again.",
        "item_scoring": {
          "candidate_attribute": "Candidate Attribute",
          "description": "Set up a score parameter to each of the items from 0 to 100%. In this case, a 100% means that a candidate with that particular parameter will get the full score allocated in the Job Matching tab",
          "empty": "No Candidate Attributes have been set up yet. Add Candidate Attributes and assign a weight to them first in the Job Matching tab",
          "hint": {
            "geolocation": "Distance from Campaign Location as set in the Campaign Main Settings",
            "multiple": "To edit these Items. Edit the options for this question in the Question tabs.",
            "talkScore": ""
          },
          "items": "Items and Score Parameters",
          "title": "Item Scoring",
          "value_label": {
            "geopoint": "Within"
          }
        },
        "shared": {
          "cancel": "Cancel",
          "candidate": "Candidate Attribute",
          "save": "Save"
        },
        "success": "Job Matching was saved successfully.",
        "title": "Job Matching",
        "weight_error": "Weight distribution has to add up 100%"
      },
      "label": {
        "actions": {
          "activate": {
            "body": "Are you sure you want to activate this campaign?",
            "title": "Activate Campaign"
          },
          "archive": {
            "body": "Are you sure you want to archive this campaign?",
            "title": "Archive Campaign"
          },
          "bulk_archive": {
            "body": "Are you sure you want to archive these campaigns?",
            "title": "Archive Campaigns"
          },
          "close": {
            "body": "Are you sure you want to stop applications for this campaign?",
            "title": "Stop applications"
          },
          "duplicate": {
            "body": "Are you sure you want to duplicate this campaign?",
            "title": "Duplicate Campaign"
          },
          "export": {
            "body": "Are you sure you want to export this campaign?",
            "title": "Export Campaign"
          },
          "favorite": {
            "body": "Are you sure you want to add this campaign to favorites?",
            "title": "Add to favorites"
          },
          "open": {
            "body": "Are you sure you want to allow applications for this campaign?",
            "title": "Allow applications"
          },
          "unfavorite": {
            "body": "Are you sure you want to remove this campaign from favorites?",
            "title": "Remove from favorites"
          }
        },
        "add_button": "Add a Button",
        "add_candidates": "Add candidates",
        "add_question_set": "Add a Question Set",
        "autoflow": "Autoflow",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "campaign_types": {
          "exit_interview": "Exit Interview",
          "inquiry": "Inquiry",
          "job_application": "Job Application",
          "job_template": "Template",
          "onboarding": "Onboarding",
          "single_time_engagement": "Broadcast",
          "unassigned": "Unassigned"
        },
        "cancel": "Cancel",
        "candidates": "Candidates",
        "categories": {
          "active": "Active",
          "archived": "Archived",
          "closed": "Closed"
        },
        "clear_filters": "Clear filters",
        "clear_selection": "Clear selection",
        "closed_campaigns": "Closed campaigns",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "created_at": "Created at",
        "created_at_by": "Created at %{date} by %{user}",
        "crop": "Crop",
        "expected_csv_columns": "Expected CSV columns",
        "explore_leads": "Explore leads",
        "facebook_pixel_id": "Facebook Pixel ID",
        "favorite": "Favorite",
        "favorites": "Favorites",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "job_category": "Job category",
        "job_matching": "Job matching",
        "job_profile": "Job profile",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "last_activity": {
          "custom": "Custom",
          "last_30_days": "Last 30 days",
          "last_7_days": "Last 7 days",
          "last_90_days": "Last 90 days",
          "title": "Last activity",
          "today": "Today"
        },
        "main_settings": "Main settings",
        "new_landing_page_design": "New Landing Page design",
        "onboarding_questions": "Onboarding questions",
        "prescreening_questions": "Prescreening Questions",
        "published_on": "Published on",
        "redirect_url": "Redirect URL",
        "see_all": "See all",
        "select_all_campaigns_count": "Select all %{count} campaigns",
        "select_multiple_campaigns": "Select multiple campaigns",
        "selected_all_current_filters": "Selected all %{count} campaigns with current filters",
        "showing_all_results": "Showing all %{count} results",
        "text_displayed": "Text displayed",
        "unfavorite": "Unfavorite"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "Set up a Weight Distribution per TalkScore parameter  from 0 to 100% for this campaign. This weight Distribution will be used to calculate the Overall Score of the application and for the Job Matching System.",
          "error": "TalkScore Settings were not saved. Please try again.",
          "subtitle": "Score Parameters",
          "success": "TalkScore Settings were saved successfully.",
          "title": "TalkScore Settings"
        }
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max %{file_size}.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "closed_campaigns_desc": "This is a new category that groups campaigns where the \"Allow new application\" option is disabled",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "delete_set_confirmation": "Are you sure you want to remove this question set from this campaign?",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "no_campaigns_found": "No campaigns found",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "question_set_consistency": "By using a Question Set, you can ensure consistency across multiple Campaigns. To edit them, go to the Question Set tab in Templates.",
        "recommended_banner": "%{width}px x %{height}px recommended.",
        "response_resubmit": {
          "disabled": "Disable the back button to prevent resubmissions (Not applicable to Onboarding campaigns)",
          "enabled": "Enable the back button to allow resubmissions (Not applicable to Onboarding campaigns)"
        },
        "search_campaigns_by": "Search campaigns by name, job title, or keyword (e.g., 'Sales Associate')",
        "select_multiple_campaigns": {
          "desc1": "This option allows user to filter Leads by using the multiple selection in this view",
          "desc2": "Other options like \"Stop new applications\" could be added as options for multiple campaigns"
        },
        "select_question_set": "Select a Question Set to add",
        "selected_number_campaigns": "Selected %{count} campaigns",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully.",
        "view_selected_set_info": "View the Selected Question Set, remove it from this Campaign or replace it by another existing set. To edit the questions directly, go to the Question Set Templates tab."
      }
    },
    "candidate": {
      "application": {
        "id": "Application ID",
        "talkscore": {
          "active_listening": {
            "A0": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A1": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A1+": "Difficulty in understanding spoken English, frequently requiring repetition and rephrasing; struggles significantly with unscripted speech.",
            "A2": "Can understand basic spoken English, particularly in familiar situations, though may miss nuances and implied meanings.",
            "A2+": "Can understand basic spoken English, particularly in familiar situations, though may miss nuances and implied meanings.",
            "B1": "Understands main points of clear standard speech on familiar matters; may require occasional clarification in noisy backgrounds or with idiomatic language.",
            "B1+": "Understands main points of clear standard speech on familiar matters; may require occasional clarification in noisy backgrounds or with idiomatic language.",
            "B2": "Can follow extended speech and complex lines of argument provided the topic is reasonably familiar; may miss some subtleties and cultural references.",
            "B2+": "Can follow extended speech and complex lines of argument provided the topic is reasonably familiar; may miss some subtleties and cultural references.",
            "C1": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech.",
            "C1+": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech.",
            "C2": "Exhibits excellent understanding of spoken language even when involving abstract, structurally complex or highly idiomatic speech."
          },
          "breakdown": "Score Breakdown",
          "categories": {
            "active_listening": "Active Listening",
            "comprehension": "Comprehension",
            "fluency": "Fluency",
            "grammar": "Grammar",
            "pronunciation": "Pronunciation",
            "vocab": "Vocabulary"
          },
          "comprehension": {
            "A0": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A1": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A1+": "Comprehends only very basic spoken and written English with significant difficulties in understanding sentences.",
            "A2": "Can understand phrases and the highest frequency vocabulary related to areas of most immediate personal relevance; struggles with complex texts and speech.",
            "A2+": "Can understand phrases and the highest frequency vocabulary related to areas of most immediate personal relevance; struggles with complex texts and speech.",
            "B1": "Can understand the main points of clear standard input on familiar matters; may have trouble with complex or abstract content.",
            "B1+": "Can understand the main points of clear standard input on familiar matters; may have trouble with complex or abstract content.",
            "B2": "Understands detailed reasoning in both spoken and written language, including technical discussions in their specialization, though may struggle with highly abstract or culturally loaded texts.",
            "B2+": "Understands detailed reasoning in both spoken and written language, including technical discussions in their specialization, though may struggle with highly abstract or culturally loaded texts.",
            "C1": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings.",
            "C1+": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings.",
            "C2": "Fully understands almost everything heard or read with ease, including indirect, figurative, and implied meanings."
          },
          "error": {
            "subtitle": "Please refresh the page or try again later",
            "title": "Oops! Something went wrong while loading this report."
          },
          "fluency": {
            "A0": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A1": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A1+": "Speech is very slow and often halted by searches for expressions and formulations, leading to disjointed communication.",
            "A2": "Can manage simple, rehearsed speech but struggles to speak spontaneously and connect ideas fluidly, resulting in frequent pauses.",
            "A2+": "Can manage simple, rehearsed speech but struggles to speak spontaneously and connect ideas fluidly, resulting in frequent pauses.",
            "B1": "Shows moderate fluency, capable of maintaining a conversation despite some hesitation and uneven speech flow.",
            "B1+": "Shows moderate fluency, capable of maintaining a conversation despite some hesitation and uneven speech flow.",
            "B2": "Speech is generally fluent with only occasional repetition or self-correction; hesitation is usually content-related rather than to search for language.",
            "B2+": "Speech is generally fluent with only occasional repetition or self-correction; hesitation is usually content-related rather than to search for language.",
            "C1": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow.",
            "C1+": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow.",
            "C2": "Speech is fluid and spontaneous with rare interruptions or hesitation, demonstrating effective command of idiomatic expressions and natural flow."
          },
          "generated_on": "Generated on",
          "grammar": {
            "A0": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A1": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A1+": "Grammar control is very limited; errors are pervasive and often obstruct understanding.",
            "A2": "Shows some control over basic grammatical structures, though complex sentences are often error-prone, occasionally impeding meaning.",
            "A2+": "Shows some control over basic grammatical structures, though complex sentences are often error-prone, occasionally impeding meaning.",
            "B1": "Grammar is generally correct for familiar topics, though mistakes may occur in more complex structures or unfamiliar situations.",
            "B1+": "Grammar is generally correct for familiar topics, though mistakes may occur in more complex structures or unfamiliar situations.",
            "B2": "Good grammatical control; errors occur but do not typically affect meaning, and complex structures are handled with some confidence.",
            "B2+": "Good grammatical control; errors occur but do not typically affect meaning, and complex structures are handled with some confidence.",
            "C1": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally.",
            "C1+": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally.",
            "C2": "Demonstrates strong grammatical control; errors are rare and minor, with a clear ability to use complex grammar forms naturally."
          },
          "overall": {
            "A0": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A1": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A1+": "This score range indicates minimal command of the English language. Candidates within this band demonstrate considerable difficulties in understanding and expressing basic English, limiting their ability for effective communication.",
            "A2": "Candidates scoring in this range possess a limited command of the language. They are able to understand and communicate basic English in familiar situations, but their proficiency is not sufficient for complex or less familiar scenarios, limiting their ability for effective communication.",
            "A2+": "Candidates scoring in this range possess a limited command of the language. They are able to understand and communicate basic English in familiar situations, but their proficiency is not sufficient for complex or less familiar scenarios, limiting their ability for effective communication.",
            "B1": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B1+": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B2": "Candidates in this score range have a strong command of the English language. They can engage in extended discussions and understand detailed information. Although minor language errors might occur, they rarely reduce communication effectiveness.",
            "B2+": "Candidates in this score range have a strong command of the English language. They can engage in extended discussions and understand detailed information. Although minor language errors might occur, they rarely reduce communication effectiveness.",
            "C1": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting.",
            "C1+": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting.",
            "C2": "This score range indicates a near native command of the English language. Candidates exhibit the ability to fluently and accurately understand and use complex language, adeptly handling advanced communication in any setting."
          },
          "overall_score": "Overall Score",
          "pronunciation": {
            "A0": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A1": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A1+": "Pronunciation is heavily influenced by candidates' first language, often making comprehension difficult without considerable effort from both the speaker and listener.",
            "A2": "Pronunciation errors are still frequent and may limit understanding when both listening and speaking, but basic phrases and expressions can be generally comprehensible.",
            "A2+": "Pronunciation errors are still frequent and may limit understanding when both listening and speaking, but basic phrases and expressions can be generally comprehensible.",
            "B1": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B1+": "This score range reflects a fair level of proficiency in English. Candidates can understand and discuss familiar subjects but might struggle with new subjects or fast speakers. Communication may be flawed by grammatical inaccuracies, fluency or pronunciation, which can affect communication but not limit it.",
            "B2": "Candidates pronounce most words correctly and are generally understood by native speakers, despite the occasional accent influence and mistakes.",
            "B2+": "Candidates pronounce most words correctly and are generally understood by native speakers, despite the occasional accent influence and mistakes.",
            "C1": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication.",
            "C1+": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication.",
            "C2": "Pronunciation is clear and closely approximates that of a native speaker, allowing for smooth and effective communication."
          },
          "questions": "Scored Questions",
          "reading": {
            "likely": {
              "description": "Voice analysis and speech-pattern data suggest the candidate was likely reading from a script. The assessment is designed to evaluate spoken fluency, so reading may impact their score. Please review a short segment of the recording and treat the results with caution.",
              "title": "Very likely reading"
            },
            "suspected": {
              "description": "Some indications of reading were found (e.g., frequent micro-pauses or unusually precise articulation). The response still contains natural elements, but you may wish to review the recording before relying on the fluency score.",
              "title": "Possibly scripted"
            }
          },
          "see_less": "See less",
          "see_more": "See more",
          "vocab": {
            "A0": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A1": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A1+": "Vocabulary range is very limited, restricted, insufficient for basic conversations or conveying precise meaning.",
            "A2": "Vocabulary is sufficient for basic conversations about familiar topics but lacks diversity and precision, limiting expression especially in unfamiliar contexts.",
            "A2+": "Vocabulary is sufficient for basic conversations about familiar topics but lacks diversity and precision, limiting expression especially in unfamiliar contexts.",
            "B1": "Candidates have a reasonable range of vocabulary for familiar topics and can sometimes paraphrase successfully when lacking specific vocabulary.",
            "B1+": "Candidates have a reasonable range of vocabulary for familiar topics and can sometimes paraphrase successfully when lacking specific vocabulary.",
            "B2": "Vocabulary range is broad enough to discuss a variety of topics with some detailed expressions; occasional inaccuracies do not hinder communication.",
            "B2+": "Vocabulary range is broad enough to discuss a variety of topics with some detailed expressions; occasional inaccuracies do not hinder communication.",
            "C1": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately.",
            "C1+": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately.",
            "C2": "Vocabulary is extensive and nuanced, allowing candidates to express complex and subtle ideas effectively and accurately."
          }
        }
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "landing_page_sop_up_screen": "Landing Page Pop-up Screen",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "listings": {
        "button": {
          "cancel": "Cancel",
          "save": "Save",
          "upload": "Upload"
        },
        "description": "This page is where your selected job application campaigns are displayed, letting candidates view your job openings and apply through their respective Landing Pages",
        "employee_referral_program": {
          "are_you_an_employee": "Are you an employee?",
          "desc_1": "Enter your details to generate your personal referral link. You can share this link with friends so they can apply to any job listed here.",
          "desc_2": "Once submitted, we'll send you a link you can share with friends-referrals apply to any job listed here",
          "get_link": "Get link",
          "get_your_referral_link": "Get your referral link",
          "get_your_referral_link_button": "Get your referral link",
          "label": {
            "actions": "Actions",
            "activate": "Activate",
            "created_at": "Created At",
            "deactivate": "Deactivate",
            "deactivated_at": "Deactivated At",
            "email": "Referrer Email",
            "erp_job_listing_url": "ERP Job Listing URL",
            "first_name": "Referrer First Name",
            "last_name": "Referrer Last Name",
            "status": {
              "active": "Active",
              "deactivated": "Deactivated",
              "title": "Status"
            }
          },
          "no_data": "No data available",
          "refer_a_friend": "Refer a friend",
          "register_referrer": "Register as a Referrer",
          "thank_you": {
            "desc_1": "We've also sent this link to: <b>%{email}</b>",
            "desc_2": "<b>Didn't receive the email?</b><br /> Check your spam folder or contact your HR team for help.",
            "desc_3": "If you're experiencing any issues receiving your email, please contact your HR team.",
            "desc_4": "Want to update your details? Click <b>Return</b> to go back",
            "return": "Return",
            "subtitle": "Your Referral Link",
            "title": "Your referral link is ready"
          },
          "title": "Employee Referral Program",
          "validation": {
            "email_invalid": "Invalid email address",
            "email_required": "Email is required",
            "first_name_required": "First name is required",
            "last_name_required": "Last name is required"
          }
        },
        "input": {
          "label": {
            "banner": "Banner",
            "banner_allowed_types": "Allowed file types: jpg, jpeg and png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copied to Clipboard",
            "header_char_count": "%{count}/60 characters",
            "listings_url": "Job Listing Page URL",
            "page_header": "Page Header"
          },
          "placeholder": {
            "page_header": "Search Job Openings at %{company}"
          }
        },
        "messages": {
          "error": "Settings were not saved. Please try again.",
          "success": "Settings were saved successfully."
        },
        "page": {
          "button": {
            "apply": "Apply",
            "first": "First",
            "last": "Last",
            "search": "SEARCH"
          },
          "input": {
            "keywords": "Keywords",
            "location": "Location",
            "remote": "Remote"
          },
          "label": {
            "default_header": "Search Job Openings at %{company}",
            "go_to_top": "Go to the top",
            "job_count": "Displaying %{count} of %{total} jobs",
            "no_results": "No Results",
            "salary_undisclosed": "Undisclosed"
          },
          "source": "Job Listing Page"
        },
        "title": "Job Listing Page"
      },
      "meta_settings": {
        "connect_button": "Connect with WhatsApp",
        "description": "Connect your WhatsApp Business Account and manage the phone numbers Talkpush uses to connect with candidates.",
        "destroy_confirmation_dialog": {
          "actions": {
            "cancel": "Cancel",
            "confirm": "Confirm"
          },
          "description": "Removing this number may disrupt ongoing conversations due to connectivity issues with other available numbers. The number will not be deleted from your WhatsApp Business Account.",
          "title": "Remove this phone number?"
        },
        "feedback": {
          "phone_record_destroy": {
            "error": "There was an error removing %{phone_number} from Talkpush. Please try again.",
            "success": "%{phone_number} has been removed from Talkpush."
          },
          "phone_record_subscribe": {
            "already_taken_phone_number": "Your WhatsApp number was already registered in Talkpush. Please contact support if you need migration assistance.",
            "error": "We couldn’t connect your WhatsApp number. Please try again.",
            "locked_phone_number": "Your WhatsApp number can't be connected because a two-step verification PIN has been set. Please turn off the two-step verification feature in the WhatsApp Manager App and try again.",
            "numberless_whatsapp_account": "A phone number is required to connect your WhatsApp Business Account to Talkpush. Please select a connection option that provides a phone number.",
            "success": "Your WhatsApp number has been connected successfully to Talkpush."
          },
          "phone_record_subscribe_to_calls": {
            "error": "Could not enable WhatsApp calls for {{phone_number}}",
            "success": "Whatsapp calls enabled for {{phone_number}}"
          }
        },
        "phone_records_table": {
          "actions": {
            "navigate_to_whatsapp_manager": "Open WhatsApp Manager",
            "remove_phone_record": "Remove Number",
            "subscribe_to_calls": "Subscribe to calls",
            "subscribed_to_calls": "Subscribed to calls",
            "test_phone_record": "Test Phone Number"
          },
          "columns": {
            "last_access_token_update": "Last Updated",
            "owner": "Connected By",
            "phone_number": "Phone Number",
            "quality_rating": "Quality Rating",
            "status": "Status",
            "whatsapp_account_name": "Account Name"
          },
          "empty_banner": {
            "description": "Connect your WhatsApp Business Account and manage the phone numbers Talkpush uses to connect with candidates.",
            "title": "Connect WhatsApp Business Account"
          },
          "error_banner": {
            "action": "Try again",
            "description": "We couldn't load your WhatsApp numbers. Please try again.",
            "title": "Something went wrong"
          },
          "fallback_values": {
            "country": "Unknown Country",
            "last_access_token_update": "Unknown",
            "owner": "Unknown",
            "phone_number": "Unknown",
            "whatsapp_account_name": "Unknown"
          },
          "values": {
            "quality_rating": {
              "high": "High",
              "low": "Low",
              "medium": "Medium",
              "unknown": "Unknown"
            },
            "status": {
              "connected": {
                "description": {
                  "healthy": "The associated phone number is working properly."
                },
                "label": "Connected"
              },
              "disabled": {
                "description": {
                  "disabled_in_talkpush": "This number was manually disabled. Messaging is blocked until it's re-enabled in the phone numbers section.",
                  "unhealthy_access_token": "The access token for this number is invalid. Re-authenticate to restore messaging capabilities.",
                  "unhealthy_meta_status": "This number is no longer connected to Meta. Please check your WhatsApp Business API setup."
                },
                "label": "Disabled"
              },
              "unknown": {
                "description": {
                  "unknown": "The status of the phone number can't be determined based on the available information. Re-connect the number to update the status."
                },
                "label": "Unknown"
              }
            }
          }
        },
        "title": "WhatsApp Business"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "landing_page_sop_up_screen": "This will be displayed as a pop-up in the Landing Pages before candidates input their information.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "document": {
      "tag": {
        "edit": {
          "click_here": "Click here.",
          "click_here_url": "https://help.talkpush.com/en",
          "description": "Configure documents for recognition, ownership validation and data extraction to existing candidate attributes. Want to know more?",
          "error": "An error ocurred, please try again later",
          "success": "Document was successfully updated.",
          "title": "Edit Document"
        },
        "form": {
          "country": {
            "description": "Select which country issues the document.",
            "title": "Country of Issue"
          },
          "data_extraction": {
            "attribute": "Candidate Attribute",
            "data_point": "Data Point",
            "description": "Extract data points from document and save them in a candidate attribute.",
            "title": "Data Extraction"
          },
          "document_status": {
            "description": "All of the possible document statuses and what they mean.",
            "failed": {
              "description": "There was a processing error.",
              "title": "Failed"
            },
            "recognized": {
              "description": "Document type matches what was requested.",
              "title": "Recognized"
            },
            "title": "Document Status",
            "unrecognized": {
              "description": "Document type does not match what was requested or was unreadable.",
              "title": "Not Recognized"
            },
            "unverified": {
              "description": "Name does not match the candidate name or was unreadable.",
              "title": "Not Verified"
            },
            "verified": {
              "description": "Document type matches what was requested and name matches the candidate name.",
              "title": "Verified"
            }
          },
          "feedback": {
            "description": "Candidates receive real-time feedback on their recognition status. If active, candidates will be redirected to the Landing Page to submit their documents.",
            "title": "Real-time Recognition Feedback"
          },
          "identity_verification": {
            "description": "Validate if the name on the document belongs to the candidate.",
            "title": "Identity Verification"
          },
          "name": {
            "description": "This name is used to identify the document for recognition and data extraction.",
            "title": "Official Name of Document"
          },
          "permissions": {
            "assigned_manager": "Only Onboarding admins can view and download",
            "owner": "Owners can view and download documents",
            "public": "Anyone with Campaign access can view and download",
            "title": "Permissions"
          },
          "recognition": {
            "description": "Validate if the document type matches what was requested.",
            "title": "Document Recognition"
          }
        },
        "list": {
          "add": "Add Document",
          "description": "Manage the documents you would like to collect from candidates. Edit your existing documents or create new ones to begin extracting data from documents.",
          "identitiy_verification": {
            "configured": "Configured",
            "not_configured": "Not Configured"
          },
          "learn_more": "Learn More.",
          "learn_more_url": "https://help.talkpush.com/en",
          "no_results": "No Results",
          "search": "Search Document by Name or Country",
          "subtitle": "Document recognition and Data extraction",
          "table": {
            "data_extraction": "Data Extraction",
            "identity_verification": "Identity Verification",
            "name": "Document Name",
            "permissions": "Permissions"
          },
          "title": "Documents"
        },
        "new": {
          "error": "An error ocurred, please try again later",
          "success": "Document was successfully created.",
          "title": "New Document"
        }
      }
    },
    "email_preference": {
      "buttons": {
        "unsubscribe": "or unsubscribe me from all communications",
        "update": "Update My Email Preferences"
      },
      "checkboxes": {
        "application_updates": {
          "description": "Receive important updates about your job applications. Unsubscribe to stop receiving updates and remove all your data from our system.",
          "title": "Application Updates"
        },
        "new_opportunities": {
          "description": "Receive news about our company and invites to apply for new jobs.",
          "title": "New Opportunities & Job Fairs"
        }
      },
      "footer": {
        "note": "unsubscribing will delete all your information and remove your applications from our system"
      },
      "header": {
        "title": "Email Preferences for"
      },
      "not_found": {
        "notice": {
          "header": "Oops! We Couldn't Find Your Information",
          "message1": "It looks like we couldn't find your information in our system. This could happen if your email has already been unsubscribed or if your application has been removed.",
          "message2": "But don't worry! You can still stay in touch. If you're interested in new opportunities, please visit our <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">Job Listing Page</a> to explore and apply for open positions."
        }
      },
      "notices": {
        "success": "Preferences Updated Successfully",
        "unsubscribe": {
          "error": "Something went wrong. Please try again.",
          "success": "You have been successfully unsubscribed from all communications."
        }
      },
      "unsubscribe_confirmation": {
        "notice": {
          "header": "You have been successfully unsubscribed from all communications.",
          "message": "We're sorry to see you go. If you change your mind in the future and are interested in new opportunities, please feel free to visit our <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">Job Listing Page</a> to explore and apply for open positions."
        }
      }
    },
    "facebook_page": {
      "record": {
        "button": {
          "disconnect": "Disconnect",
          "login": "LOG IN WITH FACEBOOK",
          "renew": "Renew",
          "renew_all": "Renew All"
        },
        "label": {
          "actions": "Actions",
          "audit": {
            "disconnected": "Disconnected by %{user}",
            "last_renew": "Last Renewed by %{user}"
          },
          "auto_renew": {
            "one": "Auto renews in 1 day",
            "other": "Auto renews in %{count} days"
          },
          "confirmation": {
            "disconnect": {
              "text": "In order to reconnect a page after it has been disconnected, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
              "title": "Disconnect Facebook Page"
            }
          },
          "create": {
            "error": "Error creating page(s). Please try again.",
            "success": "%{pages} successfully connected."
          },
          "description": "Manage your connected Facebook Pages or connect new ones to Talkpush. To connect new pages or reconnect one after an invalid token, click on Log in with Facebook and select the pages you wish to generate tokens for.",
          "disconnect": {
            "error": "Error updating %{page}. Please try again.",
            "success": "%{page} was successfully disconnected."
          },
          "facebook_id": "ID",
          "lead_ads_warning": {
            "contact": "or contact Product Support for assistance.",
            "learn_more": "Learn more here",
            "learn_more_url": "https://help.talkpush.com/en/articles/8892130-renew-or-disconnect-your-facebook-page-access-from-talkpush",
            "testing_tool": "Test your Lead Ads integration.",
            "text": "You will need to have the right level of access to correctly generate Access Tokens for Facebook Pages. Check the list of required permissions to make sure that the bots and Lead Ads integrations will function properly.",
            "title": "Warning"
          },
          "login": {
            "error": "Log In Error"
          },
          "name": "Name",
          "no_data": "No Data",
          "renew": {
            "error": "Error updating %{page}. Please try again.",
            "success": "The access token for %{page} was successfully renewed."
          },
          "required_permissions": "Required Permissions",
          "resubscribe": {
            "error": "Error updating. Please try again.",
            "success": "The access token for %{pages} successfully renewed."
          },
          "status": "Status",
          "title": "Facebook Page Access",
          "updatedAt": "Updated Date"
        },
        "modal": {
          "body": {
            "first_caption": "To reconnect them, you will have to log in with Facebook again and select them and any other page you wish to remain connected.",
            "second_caption_end": "or contact our Product Support team to guide you through this process.",
            "second_caption_link": "Learn more about the Access Tokens Dashboard",
            "second_caption_link_url": "https://help.talkpush.com/en/articles/8706222-facebook-access-token-dashboard",
            "second_caption_start": "Unsure how to proceed? →"
          },
          "button": {
            "continue": "Continue to Log in with Facebook"
          },
          "header": "Any Facebook Page previously connected will appear selected.",
          "warning": "By deselecting them, their tokens will be invalidated by Meta and the page will be disconnected."
        },
        "status": {
          "active": "Active",
          "expired": "Expired",
          "expiring_soon": "Expiring Soon",
          "invalid": "Invalid",
          "tooltip": {
            "active": "In order to use the dashboard features for this page, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "expired": "This token has expired. Click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "invalid": "This token has been invalidated by Facebook due to an authentication issue. Click on the Log in to Facebook button and follow the steps to re-authenticate it."
          }
        }
      }
    },
    "folder": {
      "label": {
        "associated_campaigns": "Associated Campaigns",
        "create_custom_folder": "Create Custom Folder",
        "create_folder": "Create Folder",
        "delete_folder": "Delete Folder",
        "description": "Description",
        "edit_folder": "Edit %{title} Folder",
        "folder_name": "Folder Name",
        "select_folders": "Select Folders",
        "settings": "Folder Settings",
        "workflow": "Workflow"
      },
      "text": {
        "associate_to_campaigns": "Associate to all existing and new Campaigns",
        "associated_campaigns": {
          "one": "%{count} associated campaign",
          "other": "%{count} associated campaigns"
        },
        "candidates_can_move_to": "Candidates can be moved to",
        "cannot_dissaociate_with_candidates": "Campaigns that are currently associated and have candidates in the folder cannot be disassociated.",
        "settings_description": "Manage your Folders, create new ones and link them to campaigns, and determine which folder movements your users can do.",
        "text_counter": "%{count}/100 characters",
        "warn_has_candidates": {
          "one": "Warning: All candidates in %{folder} must be manually moved to another folder. There is still <1>count</1> candidate in this folder in the following campaign:",
          "other": "Warning: All candidates in %{folder} must be manually moved to another folder. There are still <1>count</1> candidates in this folder in the following campaign(s):"
        },
        "workflow_description": "Determine which folders candidates can be moved to by your users’ manual actions. <1>link</1>"
      }
    },
    "guest": {
      "label": {
        "add": "Add Guest",
        "create": {
          "desc": "Configure guests in order to easily share Candidate profiles with them via Email or WhatsApp",
          "error": "An error ocurred, please try again later",
          "required_value": "Add at least one communication method to reach this Guest in order to save.",
          "success": "Guest Created Successfully",
          "title": "Create Guest"
        },
        "name": "Name",
        "new": {
          "title": "New Guest"
        },
        "no_results": "No Results",
        "phone_number": "Phone Number",
        "role": "Role",
        "search": "Search Guests",
        "update": {
          "success": "Guest Updated Successfully",
          "title": "Update Guest"
        }
      }
    },
    "job_boards": {
      "label": {
        "add_contract": "Add Contract",
        "advertise": "Advertise",
        "current_campaign_settings": "Current Campaign Settings",
        "go_to_settings": "Go to Campaign Settings"
      },
      "text": {
        "boost_reach": "Boost your candidate reach instantly",
        "campaign": {
          "access_restricted": {
            "description": "This feature is only available to users with special permissions. If you’d like access, please reach out to your account manager.",
            "title": "Access Restricted"
          },
          "description": "Instantly post your job across thousands of job boards—simplifying high-volume hiring and delivering candidates faster.",
          "final_purchase_warning": {
            "description": "All transactions on this platform are non-refundable and cannot be reversed. Please review your order carefully before completing the purchase.",
            "title": "Important Notice: Purchases Are Final"
          },
          "title": "Post this Campaign on any Job Boards"
        },
        "contract": {
          "description": "Got existing job board deals? Connect them here to effortlessly post jobs using your current agreements, saving you both time and unnecessary additional costs.",
          "title": "Bring Your Own Job Boards"
        },
        "errors": {
          "not_whitelisted": "Your account is not authorized to create job ads. Please contact support for assistance.",
          "order_limit_reached": "You have reached the maximum allowed orders for your account. To increase your limit, please contact support."
        },
        "inbound": {
          "description": "Insert this campaign's dedicated email address in the section provided by your job board for receiving applications.",
          "title": "Import candidates from Job Board postings"
        },
        "ineligible": {
          "description": "Job Advertising is only available for campaigns set to \"Job Application\" and configured to receive new applications.",
          "title": "Job Advertising is not available for this Campaign"
        },
        "job_boards": "Job Boards",
        "opn": {
          "description": "We’ll share your job with our partner job boards at no cost. Eligible postings may appear as free listings—never as sponsored or paid placements—though we can’t guarantee inclusion on every site. This free distribution is separate from paid advertising options.",
          "requirements_1": "Requires a Job Application campaign that is actively receiving applications.",
          "title": "Free Advertisement"
        }
      },
      "vonq": {
        "alert": {
          "dismiss-button": {
            "close": "Close"
          }
        },
        "basket": {
          "add": "Add to Campaign",
          "add-product": "Add to My Contracts",
          "calculating-times": "Calculating times, please wait...",
          "delivery-time": "Delivery Time",
          "delivery-time-disclaimer": "Delivery can take up to {workingDays} working days",
          "delivery-time-explanation-learn-why": "Learn why",
          "description": "Includes job marketing products and own contracts.",
          "immediate-delivery-time": "Campaign will be online immediately",
          "processing-time-disclaimer": "Your first order on these channels can take up to {workingDays} working days to process",
          "product": {
            "remove-confirmation": {
              "accept": "Accept",
              "decline": "Decline",
              "title": "Are you sure you want to remove this product?"
            },
            "time-to-process": "{timeToProcess} to process"
          },
          "products": {
            "empty": "There are no products in the basket",
            "part-of-bundle-warning": "This product belongs to the bundle you have in your basket",
            "total-amount": "Total amount",
            "wallet-balance": "Wallet balance"
          },
          "remove": "Remove from Campaign",
          "review-error-atleast-one-product-required": "At least one product or contract is required to be able to order the campaign",
          "review-error-title": "Please review the following error(s):",
          "title": "Basket",
          "title-explanation": "{quantity} channels",
          "total-delivery-and-processing-times": "Campaign will be online in {workingDays} total working days"
        },
        "campaign": {
          "add": {
            "common-fields": "Common Fields",
            "contact-information": {
              "email": "Email",
              "email-explanation": "Some channels require an email to post a job. Leave a contact email or a general company email",
              "name": "Name",
              "name-explanation": "Leave a contact name (or general company info), so that your job can be properly placed on job boards that require this information"
            },
            "copy": {
              "accept": "Copy as is",
              "decline": "Let me choose products/contracts",
              "description": "The following products/contracts was in this campaign. Do you want to duplicate campaign with these or select new products/contracts?",
              "title": "Do you want to copy campaign with existing products/contracts?"
            },
            "form-contracts": {
              "heading": {
                "title": "Added contracts"
              }
            },
            "heading": "Create Campaign",
            "job-criteria": {
              "employment-type": "Employment Type",
              "heading": "Job criteria",
              "heading-explanation": "We will use this data to better target your desired audience",
              "level-of-education": "Level of education",
              "minimum-years-of-experience": "Minimum no. years of experience"
            },
            "job-posting-details": {
              "application-link": "Link to the application page",
              "application-link-explanation": "Add the link where a candidate fills in the application (this can also be the job detail page)",
              "application-link-explanation-placeholder": "Enter a URL",
              "campaign-name": "Campaign name",
              "campaign-name-explanation": "Campaign Name is used to easily distinguish jobs in list of campaigns. For example, campaign name could be \"Software Development Manager\" while Job Title could be \"Want to lead a Team of Software Developers? Join us\". This is only shown to you and not to the candidates",
              "job-description": "Job Description",
              "job-description-explanation-1": "The job description is captured directly from your ATS, so you can immediately start editing. Important note: Not all formatting might be imported correctly. \nPlease make sure to double-check your text before ordering.",
              "job-function-explanation": "Please fill in the job function of the job",
              "job-title-placeholder": "The title of the posting across different channels where the posting is going to be published",
              "work-location": {
                "company-logo-url": "Company Logo URL",
                "company-logo-url-description": "Enter a Publicly Available URL",
                "explanation": "Add the location of where this person will work",
                "work-location": "Work location details for your vacancy"
              }
            },
            "order-fail": "Something went wrong while ordering the campaign",
            "order-success": "Your order has been placed"
          },
          "ask-status": "Ask Status",
          "audience": "Audience",
          "cancel-campaign": "Cancel Campaign",
          "cancel-campaign-confirmation": "Are you sure that you want to cancel the campaign? It's not possible to shift the payment to another campaign or get the money back.",
          "cancel-campaign-product-confirmation": {
            "accept": "Cancel Product",
            "description": "Are you sure that you want to cancel the product? It's not possible to shift the payment to another product or get the money back."
          },
          "card": {
            "channel": {
              "actions": "Actions",
              "clicks": "Clicks",
              "end-date": "End date",
              "link": "Board Link",
              "start-date": "Start date"
            },
            "create-new-from-this": "Create new from this",
            "edit": "Edit",
            "hide-campaign-details": "Hide campaign details",
            "job-id": "Job ID: {jobId}",
            "modify-date": "Last modified: {dateTime}",
            "modify-date-explanation": "Time of processed changes",
            "no-actions": "No actions",
            "not-delivered": "Not delivered yet",
            "order-date": "Order date: {date}",
            "product-take-offline-success": "Product has been taken offline",
            "show-campaign-details": "Show campaign details",
            "take-offline": "Take Offline",
            "take-offline-success": "Campaign has been taken offline",
            "target-audience": "Target Audience"
          },
          "contact-info": {
            "email-placeholder": "Enter Email Address of the Contact Person",
            "heading": "Contact Info",
            "heading-explanation": "Contact Info may be different from the Recruiter Info and the applicants will use the contact info to reach for the application",
            "name-placeholder": "Enter Full Name of the Contact Person",
            "phone-number": "Phone Number",
            "phone-number-placeholder": "Enter Phone Number of the Contact Person",
            "same-as-recruiter-info": "Contact Info is same as Recruiter Info (as recruiter info does not have a phone number, you can optionally enter your phone number)"
          },
          "contract-posting-requirements": {
            "dependent-fields-need-to-be-filled-to-get-options": "Fields \"{fieldLabels}\" need to be filled in to get options for this field",
            "dependent-fields-need-to-be-filled-to-reactively-render": "Fields \"{fieldLabels}\" need to be filled in for this field to update",
            "heading": "Posting Requirements",
            "no-required-field-entered": "No value entered for {labelName} in other forms",
            "some-section-fields-are-optional-and-hidden": "Some of the posting requirements of this section are optional and hidden!",
            "type-to-search": "Search for values by typing into the field"
          },
          "contracts-explanation": "Fill in the details the channel requires.",
          "copy-campaign-confirmation": {
            "accept": "Copy Campaign",
            "title": "Are you sure you want to duplicate this campaign?"
          },
          "copy-campaign-warning": "There were products/contracts ordered as part of this campaign which no longer exist and they have not been added to your basket",
          "copy-success": "Your campaign has been created",
          "create": {
            "continue": "Save and Continue",
            "job-portals": {
              "contact-information": "Contact information for candidates",
              "criteria": "Job criteria",
              "posting-details": "Job posting details"
            },
            "my-contracts": "My contracts"
          },
          "edit": {
            "not-editable": "Campaign is not editable",
            "ordered-product-has-no-posting-requirements": "The contract or product with the specified Ordered Product ID is not found or has no posting requirements",
            "save": "Save Campaign",
            "save-take-effect-disclaimer": "Changes may take some time to apply"
          },
          "form": {
            "heading": {
              "title": "Create your job ad(s)",
              "title-explanation": "Fill in the needed information for your job posting(s). Some fields are required by job boards to be able to post on it."
            }
          },
          "header": {
            "duplicate-to-new": "Duplicate to new campaign"
          },
          "ordered-products": "Ordered Products",
          "organization": {
            "company": {
              "logo": "Organization Company Logo"
            },
            "sidebar-company-logo": "Posting Organization Logo URL",
            "sidebar-name": "Posting Organization Name",
            "sidebar-title": "Organization"
          },
          "posting-details": {
            "allowed-html-tags": "Allowed HTML tags: {tags}",
            "description": "Description",
            "heading-explanation": "Posting details represents the Job Posting information that's going to be published in the products selected in this request.",
            "line-1": "The Organization for which the Job Posting is going to be directed.",
            "line-2": "The company that's actually hiring a candidate.",
            "organization": {
              "company-logo": "Company Logo",
              "company-logo-description": "Upload a company logo",
              "name": "Company Name",
              "name-placeholder": "Enter Name of the Company"
            },
            "salary": {
              "currency": "Currency",
              "from": "From",
              "indication": "{fromPrice}{fromCurrency} to {toPrice}{toCurrency} {period}",
              "period": "Period",
              "to": "To"
            },
            "salary-indication": {
              "from-placeholder": "Enter a value for the hour"
            },
            "sidebar-posting-description": "Posting Description",
            "sidebar-posting-employment-type": "Posting Employment Type",
            "sidebar-posting-title": "Posting Title",
            "sidebar-salary-indication-period": "Posting Salary Indication Period",
            "sidebar-salary-indication-range-currency": "Posting Salary Indication Range Currency",
            "sidebar-salary-indication-range-to": "Posting Salary Indication Range Max",
            "sidebar-title": "Posting Details",
            "sidebar-weekly-working-hours-to": "Posting Weekly Working Hours Max",
            "title-explanation": "This is the job title which will be shown to your candidates",
            "weekly-working-hours": {
              "from": "From",
              "to": "To"
            },
            "weekly-working-minutes": {
              "from-placeholder": "Enter a value for the minutes"
            }
          },
          "posting-requirements": {
            "posting-duration-days-explanation-1": "If the value entered in the field differs from the value entered during contract creation, this value will be used.",
            "posting-duration-days-explanation-2": "If the job board has its own duration field please ensure this matches it."
          },
          "product": {
            "id": "Product ID",
            "status": "Status"
          },
          "products": {
            "status": "Ordered Product Statuses"
          },
          "recruiter-info": {
            "email-explanation": "Some channels require an email to post a job. Leave a contact email or a general company email",
            "email-placeholder": "Recruiter's Email Address",
            "heading": "Recruiter Info",
            "heading-explanation": "Recruiter is the person using the ATS to create the Campaign and it's generally part of the Company whose Id we request first.",
            "name": "Full Name",
            "name-explanation": "Leave a contact name (or general company info), so that your job can be properly placed on job boards that require this information",
            "name-placeholder": "Recruiter's Full Name",
            "sidebar": {
              "name": "Recruiter Name",
              "title": "Recruiter Info"
            }
          },
          "salary": {
            "indication": "{fromPrice}{fromCurrency} to {toPrice}{toCurrency} {period}"
          },
          "save-success": "Campaign has been saved",
          "select-channels": {
            "no-items-in-basket": "You need at least one product or a contract added to campaign in order to proceed"
          },
          "smartfill": {
            "ai": "AI",
            "button": "Fill in with AI",
            "description": "AI will try to fill the form with previously provided details. It only pre-fills blank fields.",
            "failed": "Smart Fill failed, please try again later",
            "field-overlay": "Loading suggestions, please wait...",
            "smartfill": "Smart Fill",
            "status": {
              "errored": "Errored"
            }
          },
          "status": "Campaign Status",
          "status-detail": {
            "click-to-copy": "Click to copy text above",
            "more-info": "more info",
            "more-information": "More information",
            "more-information-detail": "In case the job boards ask for more specific details, you can share the error from the job board as shown below:",
            "status": {
              "awaiting-successful-payment": "awaiting successful payment",
              "in-progress": "In Progress",
              "not-processed": "Not Processed",
              "offline": "Offline",
              "online": "Online",
              "view-invoices": "view invoices"
            }
          },
          "target-group": {
            "education-level-placeholder": "Select an Education Level",
            "employment-type": "Employment Type",
            "employment-type-placeholder": "Select an Employment Type",
            "heading": "Target Group",
            "heading-explanation": "Fill in details for your target group.",
            "industry-explanation": "Please fill in the industry of the job",
            "industry-placeholder": "Select an Industry",
            "job-function-explanation": "Please fill in the function of the job",
            "seniority-placeholder": "Select a Seniority",
            "sidebar-title": "Target Group"
          },
          "urls": {
            "application-url": "Application URL",
            "application-url-explanation": "Fill in the URL that will be used as the landing page for your job application",
            "application-url-placeholder": "Enter the link for the page where the candidate will be applying for the position",
            "heading": "URLs",
            "heading-explanation": "Fill in details for your job and application pages.",
            "job-page-url": "Job Page URL",
            "job-page-url-placeholder": "Enter the link for the page with the job description",
            "sidebar-application-url": "Posting Application URL",
            "sidebar-job-page-url": "Job Description URL",
            "sidebar-title": "URLs"
          },
          "work-location": {
            "allows-remote-work": "Allows remote work?"
          },
          "working-location": {
            "address-line-1": "Address Line 1",
            "address-line-1-placeholder": "Enter First Line of Address",
            "address-line-2": "Address Line 2",
            "address-line-2-placeholder": "Enter Second Line of Address",
            "allows-remote-work": "Allows remote work?",
            "city": "City",
            "city-placeholder": "Enter City of Address",
            "country": "Country",
            "country-placeholder": "Enter Country of Address",
            "heading": "Working Location",
            "heading-explanation": "Fill in details for the location of the work.",
            "postcode": "Postcode",
            "postcode-placeholder": "Enter Postcode of Address",
            "sidebar-address-line-1": "Posting Working Location Address Line 1",
            "sidebar-city": "Posting Working Location City",
            "sidebar-country": "Posting Working Location Country",
            "sidebar-postcode": "Posting Working Location Postcode",
            "sidebar-title": "Working Location"
          }
        },
        "checkout": {
          "order-campaign": "Order campaign"
        },
        "common": {
          "application-page": "Application Page",
          "autocorrection-must-be-applied": "Following auto-correction must be applied, click to apply",
          "back-to": "Back to {previousTabTitle}",
          "bold": "Bold",
          "bullet-list": "Bullet list",
          "cannot-accept-file": "Cannot accept that file",
          "channel": "Channel",
          "channel-name": "Channel Name",
          "characters": "Characters",
          "clear-formatting": "Clear formatting",
          "contracts": "Contracts",
          "currency": "Currency",
          "diff-added-removed": "Red indicates removed values, green indicates added values",
          "education-level": "Education Level",
          "employment-type": "Employment Type",
          "enter-a-value": "Enter a value",
          "field-is-required": "This field is required",
          "field-should-be-email": "This field should be an Email",
          "field-should-be-float": "This field can only contain numbers, dots and commas.",
          "field-should-be-float-with-comma-only": "This field should not contain dots.",
          "field-should-be-more-than-zero": "This field should be more than 0",
          "field-should-be-url": "This field should be a URL",
          "field-should-be-utm": "This field should contain a valid UTM (Tracking) code",
          "field-should-contain-an-image-with-url": "This field should contain an image",
          "field-should-meet-regex": "This field does not meet the requirements. Please check the requirements by reading the information next to the label.",
          "file-too-big": "File too big, select something smaller than {size}",
          "file-upload-load-error": "An error happened while loading the file upload tool",
          "fullscreen": "Fullscreen",
          "hide-all-fields": "Hide all fields",
          "hide-optional-fields": "Hide optional fields",
          "hit-enter-for-adding-tag": "Hit enter to add your tag(s)",
          "id": "ID",
          "important-notice": "Important Notice",
          "industry": "Industry",
          "input-number-please-enter-non-default-value": "Leave it blank for the default of ({defaultValue})",
          "insert-edit-link": "Insert/edit link",
          "italic": "Italic",
          "job-page": "Job Page",
          "load-more": "Load more...",
          "loading": "Loading...",
          "loading-option": "Loading option, please wait...",
          "loading-options": "Loading options, please wait...",
          "maximum": "Maximum",
          "minimum": "Minimum",
          "network-may-be-blocking": "Your network may be blocking",
          "not-specified": "Not specified",
          "numbered-list": "Numbered list",
          "optional": "Optional",
          "or": "Or",
          "organization": "Organization",
          "please-fill-in-field": "Please fill in required fields",
          "proceed-to": "Proceed to {nextTabTitle}",
          "products": "Products",
          "range": {
            "days": {
              "long": "days",
              "short": "days"
            },
            "hourly": "hourly",
            "hours": {
              "long": "hours",
              "short": "hrs"
            },
            "minutes": {
              "long": "minutes",
              "short": "mins"
            },
            "monthly": "monthly",
            "months": {
              "long": "months",
              "short": "mos"
            },
            "seconds": {
              "long": "seconds",
              "short": "secs"
            },
            "weeks": {
              "long": "weeks",
              "short": "wks"
            },
            "yearly": "yearly"
          },
          "remove-link": "Remove link",
          "required": "Required",
          "requires-action": "Requires action",
          "section-empty": "{prefix}{title}{suffix}",
          "section-empty-prefix": "We could not find any",
          "select-a-date-placeholder": "Select a Date",
          "select-an-option": "Select an option",
          "seniority": "Seniority",
          "show-all-fields": "Show all fields",
          "show-optional-fields": "Show optional fields",
          "solution": "Solution",
          "there-are-no-options": "There are no options",
          "there-are-no-options-for-search-value": "There are no options for {inputValue}",
          "toggle-all-fields": "Show/hide all fields",
          "toggle-all-optional-fields": "Show/hide all optional fields",
          "type-to-get-options": "Type to get options",
          "weekly-working-hours": "Weekly Working Hours",
          "work-location": "Work Location",
          "working-time-indicator": "working"
        },
        "contract": {
          "add": {
            "add-new-group": "Add New Group",
            "button": "Add New Contract",
            "contract-group": {
              "name-placeholder": "Enter a group name"
            },
            "contract-group-explanation": "You can select or create a new contract group",
            "contract-name-placeholder": "Type a Contract Name",
            "credentials": {
              "authenticated": "You are authenticated with {channelName}",
              "fields-disabled-until-authenticated": "Fields will become enabled once you are authenticated",
              "heading": "Credentials",
              "initialize-authentication": "Initialize Authentication"
            },
            "edit": {
              "save-contract": "Save Contract"
            },
            "error-title": "Please review the following error(s):",
            "heading": "Create contract",
            "heading-explanation": "Fill in the needed information for your job posting(s). Some fields are required by job boards to be able to post on it",
            "instructions": {
              "following-instructions": "I understand that my contract can only be activated if I follow the instructions",
              "heading": "Instructions"
            },
            "optional-details": {
              "contract-alias-placeholder": "Enter a Contract Alias",
              "contract-expiry-placeholder": "Contract Expiry",
              "credits-placeholder": "Enter number of Credits",
              "currency": "Currency",
              "posting-duration-days-explanation-1": "Please enter how long (in days) you would like the job post to be published for.",
              "purchase-price-placeholder": "Purchase Price"
            },
            "posting-requirements-defaults": {
              "heading": "Channel Requirements Defaults",
              "heading-explanation": "You can fill in any of these values to be used for your future campaign orders."
            },
            "select-channel": "What contract would you like to add?",
            "select-channel-explanation": "Type to search and select the contract provider you wish to add",
            "select-group": "Select a Group",
            "success": "Contract \"{name}\" has been created"
          },
          "delete": "Delete Contract",
          "delete-outdated-contract": "Please delete this outdated contract and create a new one",
          "details": {
            "outdated-contract": "Outdated Contract"
          },
          "edit": {
            "success": "Contract \"{name}\" has been saved"
          },
          "filters": {
            "apply-filters": "Apply Filters",
            "channel-name": "Channel Name",
            "channel-name-placeholder": "Type a channel name",
            "group-id": "Group",
            "group-id-placeholder": "Select a Group"
          },
          "group": {
            "add": {
              "success": "Contract group \"{groupName}\" has been created"
            },
            "delete": "Remove group",
            "name": "Group",
            "remove": {
              "success": "Contract group \"{groupName}\" has been removed"
            },
            "update": {
              "success": "Contract group \"{groupName}\" has been updated"
            }
          },
          "group-conflict": {
            "accept": "Yes, remove them",
            "decline": "No, keep them",
            "description": "It is only possible to add contracts from the same contract group to your basket. In case you add a contract from another group, all previously added contracts will be removed from your basket. Are you sure you want to remove the following contracts from your basket?",
            "title": "Contract \"{contractName}\" could not be added!"
          },
          "list": {
            "contracts": {
              "list": {
                "heading": "My Contracts",
                "heading-description": "Leverage your own job board contracts for campaign publishing."
              }
            },
            "table-header": {
              "action": "Action",
              "channel-name": "Channel name",
              "expiry-date": "Contract Expiry date",
              "group-name": "Group name",
              "purchase-price": "Purchase price",
              "purchased": "Purchased"
            }
          },
          "remove": {
            "success": "Contract \"{name}\" has been removed"
          },
          "remove-contract-confirmation": {
            "accept": "Remove Contract",
            "title": "Are you sure that you want to remove the contract?"
          },
          "remove-contract-group-confirmation": {
            "accept": "Remove Group",
            "description": "Are you sure that you want to remove the group?",
            "title": "You must delete the contracts in this group before deleting the group:"
          },
          "update-contract-group-confirmation": {
            "accept": "Update Group",
            "title": "Are you sure that you want to update the group?"
          }
        },
        "product": {
          "time-indicator-with-period-and-range": "{period} working {range}"
        },
        "products": {
          "add": {
            "success": "Product added to campaign"
          },
          "details": {
            "channel": {
              "type": {
                "aggregator": "Aggregator",
                "community": "Community",
                "job-board": "Job Board",
                "product_bundle": "Product Bundle",
                "publication": "Publication",
                "service": "Service",
                "social-media": "Social Media"
              }
            },
            "cross-postings": "Cross Postings",
            "delivery-time": "Delivery Time",
            "duration": "Duration",
            "free-add-on-channel": "Free Add-On Channel",
            "free-add-on-channels-description": "Add any of these add-on channels to your basket for free if you add at least one premium channel to your basket",
            "free-add-on-channels-heading": "Free Add-on Channels",
            "industries": "Industries",
            "job-functions": "Job Functions",
            "locations": "Locations",
            "more-premium-channels-description": "Add any of these channels to your cart for more exposure for your campaign",
            "more-premium-channels-heading": "More Premium Channels",
            "price": "Price",
            "processing-time": "Processing Time",
            "processing-time-disclaimer": "Your first order may take up to {timeToSetup}",
            "recommended-channel": "Recommended Channel",
            "recommended-channels": "Recommended Channels",
            "recommended-channels-description": "Selected based on data-driven insights to maximize campaign's reach and performance."
          },
          "filters": {
            "apply-filters": "Apply Filters",
            "filter": {
              "display-all": "Display all",
              "exclude-recommendations": "Exclude recommendations",
              "recommendations-only": "Display recommendations only"
            },
            "filters-are-ignored-with-name": "When searching by product name, the Job Title, Job Function, Industries and Location filters will be ignored",
            "heading": "Channel Filters",
            "industry-placeholder": "Type an Industry...",
            "job-function-placeholder": "Select a job function",
            "job-title-placeholder": "Type a job title...",
            "my-contracts-supported-only": "Only include products with support for My Contracts",
            "name": "Product Name",
            "name-placeholder": "Type a product name...",
            "recommendations": "Recommendations",
            "region": "Product Region",
            "region-placeholder": "Type a location...",
            "search-by-product-name": "Search by Product Name",
            "sort-by": {
              "recent": "Most recently created first",
              "relevant": "Most relevant first"
            }
          },
          "more-information": "More Information",
          "remove": {
            "warning": "Product removed from campaign"
          },
          "sort-by": {
            "created-newest-to-oldest": "Newest",
            "created-oldest-to-newest": "Oldest",
            "ordered-high-to-low": "Most Ordered",
            "ordered-low-to-high": "Least Ordered",
            "price-high-to-low": "High Price",
            "price-low-to-high": "Low Price",
            "recommended-first": "Recommended First",
            "relevant": "Relevant",
            "title": "Sort By"
          },
          "tabs": {
            "contracts": "My Contracts",
            "my-contracts": {
              "similar-channels": "Explore Similar Channels"
            },
            "recommendations": "Channel Recommendations",
            "relevant": "Other Relevant Channels"
          },
          "type-filter-by": {
            "bundles-only": "Bundles Only",
            "free-add-on-only": "Free Add-on Only",
            "mixed": "All Types"
          }
        },
        "user-journey": {
          "contract": {
            "back-to-list": "Back to Contracts",
            "create-contract": "Create Contract"
          },
          "job-marketing": {
            "add-contracts": "Add Contracts",
            "add-contracts-explanation": "Add own contract to those that support this feature.",
            "search-products": "Explore Other Relevant Channels",
            "search-products-explanation": "Showing results for {productNameInput}.",
            "select-contracts": "Manage Contracts",
            "select-contracts-explanation": "Manage your existing contracts.",
            "select-products": "Get Recommendations",
            "select-products-explanation": "This channel mix shows to be the best for your target audience based on 60 million records of job performance data and similar jobs."
          },
          "job-posting": {
            "basket-summary": "Basket Summary",
            "order-confirmation": "Thank you for your order",
            "order-confirmation-create-new-campaign": "Create a new campaign",
            "order-confirmation-explanation-1": "Your campaign will be online on all channels within {daysToProcess} working days.",
            "order-confirmation-explanation-2": "Please be aware, that some job platforms require an additional setup time the first time you use them, which might take up to {daysToSetup} working days.",
            "order-review": "Order Review",
            "order-review-explanation": "Review your campaign details before ordering."
          },
          "landing": {
            "get-recommendations": "Get Recommendations",
            "heading": "Let's target the right talent",
            "heading-explanation": "We will use this information to recommend you the best performing channels, so you can target the right candidates.",
            "industries-explanation": "Enter the industries for this company",
            "job-function-explanation": "Select a matching job function (used to select the best performing channels)",
            "job-title-explanation": "Enter and select the job title that describes the role (used to select the best performing channels)",
            "location-explanation": "Enter the location where you would like to look for candidates"
          },
          "navigation": {
            "create-ads": "Create job ad(s)",
            "get-recommendations": "Get Recommendations",
            "next-step": "Next{delimiter} {stepTitle}",
            "order-campaign": "Order Campaign",
            "previous-step": "Previous{delimiter} {stepTitle}",
            "select-channels": "Select channels"
          },
          "order-confirmation": "Order Confirmation"
        }
      }
    },
    "landing_page": {
      "answer": {
        "booking": {
          "no_answer": "No answer provided"
        }
      },
      "apply_resume": {
        "modal": {
          "button": {
            "choose_file": "Choose File",
            "upload_again": "Upload Again"
          },
          "description": {
            "empty": "PDF, DOCX (max 10MB)",
            "failed": "Please try again",
            "invalid_file": "Please check that you sent the right document and that it is legible",
            "missing_contact_details": "Please update your resume and try again",
            "not_supported_file": "Please upload a PDF, DOCX file, 10MB max",
            "parsing": "We're analyzing your resume",
            "success": "Resume uploaded successfully",
            "uploading": "We're analyzing your resume"
          },
          "title": {
            "empty": "Upload your resume",
            "failed": "An error occurred while anlayzing your resume",
            "invalid_file": "Oops! This does not look like a resume",
            "missing_contact_details": "Oops! The uploaded resume is missing essential contact details",
            "not_supported_file": "File error",
            "parsing": "Uploading resume...",
            "success": "Resume uploaded successfully",
            "uploading": "Uploading resume..."
          }
        },
        "title": "Apply With Resume"
      },
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get hold of you and update you on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "consent": "This site only uses session cookies which is essential to be able to navigate the site and use its features and functionalities. No personally identifiable data is collected by session cookies.",
      "label": {
        "audio": "Audio",
        "booking": {
          "appointment_date": "Date & Time",
          "appointment_location": "Location",
          "cancel": "Cancel",
          "confirm": "Confirm",
          "duration": "Duration",
          "reschedule": "Reschedule",
          "timezone": "Time Zone"
        },
        "click_download": "Click here to download",
        "continue": "Continue",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "no_answer": "Not answered within time limit",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "remote_type": "Remote Type",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "upload_again": "Upload Again",
        "upload_time": "Uploading video might take a while, please wait.",
        "view_open_positions": "View Open Positions",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "notifications": {
        "prefilled_answers": {
          "linkedin": {
            "description": "We’ve used your LinkedIn profile to fill in some fields. Please review the information and update any sections that are missing or need adjustments.",
            "title": "Quick Start with LinkedIn"
          },
          "resume": {
            "description": "We’ve used your resume to fill in some fields. Please review the information and update any sections that are missing or need adjustments.",
            "title": "Quick Start with Resume"
          }
        }
      },
      "persistent_privacy_policy_link": {
        "click": "Click <a target=\"_b\" href=\"https://talkpush.com/privacy/\">here</a> to read their privacy policy.",
        "info": "We use a third-party service called Talkpush to help us collect the information we need to screen applicants and make recruitment decisions."
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "booking": {
          "appointment_confirmation": {
            "description": "A confirmation message has been sent to your preferred communication channel.",
            "reschedule": "Need to make a change?",
            "title": "Your appointment is scheduled"
          },
          "appointment_creation_error": "An error occurred while creating your appointment. Please try again.",
          "errors": {
            "booking_unavailable": {
              "description": "There are no open slots right now. Don't worry, a recruiter will be in touch soon to help you schedule your appointment.",
              "title": "All Slots are Full"
            },
            "failed_calendar_fetch": {
              "action": "Refresh",
              "description": "We're having trouble loading the appointment slots. Please try refreshing.",
              "title": "Something went wrong"
            },
            "no_available_slots": {
              "description": "There are no open slots right now. Don't worry, a recruiter will be in touch soon to help you schedule your appointment.",
              "title": "All Slots are Full"
            },
            "slot_booked": {
              "description": "That slot was just taken. Please pick another available time."
            }
          },
          "loading": "Curating your appointment slots...",
          "no_date_selected": "Select a date to see the available slots",
          "no_slot_selected": "No slot has been selected"
        },
        "camera_not_permitted": "Camera access is blocked.",
        "close_to_new_applications": "This job is no longer accepting applications. Click on the button below to view all open positions.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "dropdown_instruction": "Select an option",
        "expired_signature": {
          "check_email": "Please check your email for a new link",
          "close": "You can close this window",
          "description": "For your security, links expire after a certain time. We have already sent you a new link via email. Please open the latest email and click the new link provided to continue",
          "please_wait": "Please wait",
          "sub_description": "If you don't see the email shortly, please check you spam or junk folder",
          "title": "The link has expired"
        },
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "invalid_location": "Enter a valid location.",
        "job_type_options": {
          "contract": "Contract",
          "default": "Apply to know job type",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "not_supported_browser": {
          "text": "Click the three dot menu at the top right corner of the screen and open this link on your preferred browser to continue.",
          "title": "You won’t be able to complete this questionnaire in the Facebook browser."
        },
        "our_social_media": "Our Social Media",
        "play_media": {
          "answer": "played",
          "instruction": "Click play to begin, then click the 'next' button to move to the next question.",
          "local_storage_not_present": "Browser not supported"
        },
        "pop_up_privacy_policy": "By clicking Continue, you are agreeing to the <a href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider. This will automatically check the box in the form.",
        "pop_up_privacy_policy_with_sms": "By clicking continue, you agreeing to receive text messages from %{company} and also agreeing to the <a target=\"_blank\" href=\"%{policy_url}\">Privacy Policy</a> and the service provider’s <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a>. Message frequency will vary. Message and data rates may apply. Reply HELP for help. Reply STOP to opt out.",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "processing_answers": "Please give us a moment while we process your answers.",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "rejected_candidate": {
          "description": "This link is no longer active. Please review additional emails or message sent you with updated link to complete this step.",
          "explore_openings_cta": "Explore Current Openings",
          "headline": "Thanks for Your Interest"
        },
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "scroll_to_continue": "Please scroll to the bottom to enable the Continue button.",
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "sms_privacy_policy_company_only": "By checking this box, you agree to receive text messages from %{company} and also agree to our <a target=\"_blank\" href=\"%{policy_url}\">Privacy Policy</a> and the service provider’s <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a>. Message frequency will vary. Message and data rates may apply. Reply HELP for help. Reply STOP to opt out.\n",
        "sms_privacy_policy_company_with_terms": "By checking this box, you agree to receive text messages from %{company} and also agree to our <a target=\"_blank\" href=\"%{policy_url}\">Privacy Policy</a>, <a target=\"_blank\" href=\"%{terms_and_conditions_url}\">Terms and Conditions</a>, and the service provider’s <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a>. Message frequency will vary. Message and data rates may apply. Reply HELP for help. Reply STOP to opt out.",
        "sms_privacy_policy_default": "By checking this box, you agree to receive text messages from %{company} and also agree to the <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider. Message frequency will vary. Message and data rates may apply. Reply HELP for help. Reply STOP to opt out.",
        "talkscore_instructions": "Recordings should have a minimum of %{min} seconds and a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "talkscore_listen_and_repeat_instructions": "Recordings should have a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": {
            "failed": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "max_retries": {
              "text": "You have reached the maximum number of retries for this document. Click next to continue to the next question or submit to finish this part of your process.",
              "title": "Oops! This does not look like the document we asked for."
            },
            "not_supported": "Some files cannot be uploaded",
            "partially_recognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Make sure this is the document we asked for."
            },
            "recognition_error": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "unrecognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Oops! One of your documents does not look like the document we asked for."
            },
            "upload_error": {
              "text": "Please try again.",
              "title": "Oops! We encountered a problem while trying to upload your document."
            }
          },
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB.",
          "status": {
            "failed": "Not Recognized",
            "partially_recognized": "Not Recognized",
            "processing": "Processing",
            "recognition_error": "Not Recognized",
            "recognized": "Recognized",
            "unrecognized": "Not Recognized",
            "upload_error": "Upload Error",
            "uploaded": "Uploaded"
          },
          "success": "Your document has been recognized. Click to continue with the next question."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    },
    "message": {
      "editor": {
        "controls": {
          "alignment": {
            "buttons": {
              "center": "Align Center",
              "left": "Alight Left",
              "right": "Align Right"
            }
          },
          "basic_format": {
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline"
          },
          "call_to_action": {
            "buttons": {
              "add": "Add Button",
              "cancel": "Cancel",
              "edit": "Edit Button",
              "remove": "Remove Button",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "emoji": {
            "labels": {
              "emoji": "Emoji"
            }
          },
          "font_size": {
            "buttons": {
              "add": "Font Size"
            }
          },
          "image": {
            "buttons": {
              "add": "Add"
            },
            "labels": {
              "image": "Image",
              "paste_image_url": "Paste Image URL"
            }
          },
          "link": {
            "buttons": {
              "add": "Add Link",
              "cancel": "Cancel",
              "edit": "Edit Link",
              "remove": "Remove Link",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "token": {
            "buttons": {
              "tokens": "Tokens"
            }
          }
        }
      },
      "label": {
        "delete": "Delete",
        "duplicate": "Duplicate",
        "edit": "Edit"
      },
      "template": {
        "caption": "The Template Name will help you tell the templates apart, so make it unique and identifiable.",
        "character_count": "%{count} / %{limit} characters",
        "create_new": "Create New",
        "description": "Configure Message Templates for all channels to be used in Autoflow, for Bulk Actions, Folder Movements and as Quick Replies in all stages of the hiring process.",
        "email": {
          "name": "Email Template Name",
          "subject_line": "Subject Line",
          "tab": "Email",
          "title": "Email Templates"
        },
        "input": {
          "search_bar": {
            "placeholder": "Search Message Templates"
          }
        },
        "messenger": {
          "name": "Messenger Template Name",
          "tab": "Messenger",
          "title": "Messenger Templates"
        },
        "sms": {
          "name": "SMS Template Name",
          "tab": "SMS",
          "title": "SMS Templates"
        },
        "text": {
          "approved_by_meta": "Approved by Meta",
          "created_by_admin": "Created by Admin",
          "created_on": "Created on %{date} by %{name}",
          "last_edited_on": "Edited on %{date} by %{name}",
          "linked_campaigns_description": "This Message Template is being used for Autoflow in the following Campaigns",
          "update_from_template": "Update Message from Template",
          "update_from_template_confirmation": "This message is currently linked to a Message Template. If you edit it, it will be unlinked from the Template and any other changes will have to be done manually to this Autoflow action as any bulk edits to the Template will no longer be applied to it.",
          "update_template": "Update Message Template",
          "update_template_confirmation": "By updating this Message Template, all Autoflow actions using it will be updated as well. Do you want to proceed?"
        },
        "title": "Message Templates",
        "whatsapp": {
          "name": "WhatsApp Template Name",
          "tab": "WhatsApp",
          "title": "WhatsApp Templates"
        }
      },
      "tokens": {
        "agency": {
          "description": "Name of the agency",
          "title": "Agency Name"
        },
        "agency_user": {
          "description": "Name of the agency user",
          "title": "Agency User"
        },
        "aspiring_minds_assessment_link": {
          "description": "Personalized link to Aspiring Minds assessment",
          "title": "Aspiring Minds assessment link"
        },
        "aspiring_minds_login_link": {
          "description": "Personalized link to Aspiring Minds login",
          "title": "Aspiring Minds login link"
        },
        "aspiring_minds_password": {
          "description": "Aspiring Minds password",
          "title": "Aspiring Minds password"
        },
        "aspiring_minds_svar_url": {
          "description": "Personalized link to Aspiring Minds SVAR assessment",
          "title": "Aspiring Minds SVAR assessment link"
        },
        "aspiring_minds_username": {
          "description": "Aspiring Minds username",
          "title": "Aspiring Minds username"
        },
        "assigned_recruiter": {
          "description": "Full name of the assigned recruiter",
          "title": "Assigned Recruiter"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Link to the assigned manager's calendar scheduler",
          "title": "Assigned Recruiter Calendar Scheduler URL"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "My Calendar appointment date",
          "title": "Calendar Date"
        },
        "calendar_time_end": {
          "description": "My Calendar appointment time end",
          "title": "Calendar Time End"
        },
        "calendar_time_start": {
          "description": "My Calendar appointment time start",
          "title": "Calendar Time Start"
        },
        "call_center_agent_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent assessment",
          "title": "SHL Call Center Agent Assessment URL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent Secondary assessment",
          "title": "SHL Call Center Agent Secondary Assessment URL"
        },
        "candidate_first_name": {
          "description": "Candidate's first name",
          "title": "Candidate First Name"
        },
        "candidate_id": {
          "description": "Candidate's application ID",
          "title": "Candidate ID"
        },
        "candidate_name": {
          "description": "Candidate's full name",
          "title": "Candidate Name"
        },
        "channel_optin_url": {
          "description": "Link to WhatsApp Opt-In page",
          "title": "WhatsApp Opt-in URL"
        },
        "chat_attachment": {
          "description": "Personalized chat ID to request files by Messenger",
          "title": "Chat Attachment"
        },
        "choose_position_link": {
          "description": "Personalized link to show job cards on Messenger",
          "title": "Choose Position Link"
        },
        "city": {
          "description": "Campaign's job location",
          "title": "Campaign City"
        },
        "company": {
          "description": "Name of your company",
          "title": "Company"
        },
        "emmersion_sign_in_url": {
          "description": "Sign In link to Emmersion assessments",
          "title": "Emmersion Link"
        },
        "erp_referrer_email": {
          "description": "Email of the person who referred a candidate",
          "title": "ERP Referrer Email"
        },
        "erp_referrer_name": {
          "description": "Name of the person who referred a candidate",
          "title": "ERP Referrer Name"
        },
        "harver_assessment_link": {
          "description": "Direct link to start or resume the assigned Harver assessment",
          "title": "Harver Assessment Link"
        },
        "hireiq_assessment_link": {
          "description": "Personalized link to Hire IQ assessment",
          "title": "Hire IQ Link"
        },
        "hireiq_pin": {
          "description": "Hire IQ PIN number",
          "title": "Hire IQ PIN"
        },
        "insert_picture": {
          "description": "Insert an image to be sent via email or Messenger",
          "title": "Insert Picture"
        },
        "insert_video": {
          "description": "Insert an video to be sent via email or Messenger",
          "title": "Insert Video"
        },
        "interview_page_url": {
          "description": "Personalized link to the landing page form",
          "title": "Interview Link"
        },
        "interview_url": {
          "description": "Personalized URL to the landing page form",
          "title": "Interview URL"
        },
        "job_landing_page_url": {
          "description": "Link to the job description page",
          "title": "Job Landing Page URL"
        },
        "job_title": {
          "description": "Job the candidate applied for",
          "title": "Job Title"
        },
        "mail_attachment": {
          "description": "Personalized email ID to request files by email",
          "title": "Mail Attachment"
        },
        "messenger_call_to_action_link": {
          "description": "Messenger Call To Action Link",
          "title": "Messenger Call To Action Link"
        },
        "messenger_interview_link": {
          "description": "Personalized link to trigger interview questions on Messenger",
          "title": "Messenger Interview Link"
        },
        "messenger_interview_url": {
          "description": "Personalized URL to trigger interview questions on Messenger",
          "title": "Messenger Interview URL"
        },
        "my_calendar_scheduler_url": {
          "description": "Link to your calendar scheduler",
          "title": "My Calendar Scheduler URL"
        },
        "onboarding_form_url": {
          "description": "Link to the onboarding online form",
          "title": "Onboarding Form URL"
        },
        "onboarding_link": {
          "description": "Link to the onboarding chatbot",
          "title": "Onboarding Link"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Personalized link to SHL Chat assessment",
          "title": "SHL Pre Employment Chat Assessment URL"
        },
        "reapply_retention_period": {
          "description": "Campaign's cooling period",
          "title": "Re-apply Retention Period"
        },
        "recruiter_first_name": {
          "description": "First name of the assigned recruiter",
          "title": "Assigned Recruiter First Name"
        },
        "recruitment_center_scheduler_url": {
          "description": "Link to the campaign's recruitment center scheduler",
          "title": "Recruitment Center Scheduler URL"
        },
        "referee": {
          "description": "Name of the person who referred a candidate",
          "title": "Referree"
        },
        "referrer": {
          "description": "Name of the person who referred a candidate",
          "title": "Referrer Name"
        },
        "referrer_employee_id": {
          "description": "Employee ID of the person who referred a candidate",
          "title": "Referrer Employee ID"
        },
        "rejected_reasons": {
          "description": "Reasons for rejecting the candidate",
          "title": "Rejection Reasons"
        },
        "scheduled_at": {
          "description": "Candidate's scheduled date of interview",
          "title": "Scheduled at (Recruitment Center)"
        },
        "scheduled_at_recruiter_calendar": {
          "description": "Candidate's scheduled date of interview",
          "title": "Scheduled at (Recruiter Calendar)"
        },
        "scheduler_url": {
          "description": "Link to the campaign's recruitment center scheduler",
          "title": "Scheduler Link"
        },
        "shortlisted_reasons": {
          "description": "Reasons for shortlisting the candidate",
          "title": "Shortlisted Reasons"
        },
        "site_location": {
          "description": "Company site or branch where new hire will be assigned or trained",
          "title": "Site Location"
        },
        "svar_spoken_english_assessment_url": {
          "description": "Personalized link to SVAR Spoken English assessment",
          "title": "SVAR Spoken English Assessment URL"
        },
        "training_batch": {
          "description": "Batch or wave of trainees for onboarding",
          "title": "Training Batch"
        },
        "training_date": {
          "description": "Date of training as part of onboarding",
          "title": "Training Date"
        },
        "training_program": {
          "description": "Class or program of training for onboarding",
          "title": "Training Program"
        },
        "training_time": {
          "description": "Time of onboarding training",
          "title": "Training Time"
        },
        "training_venue": {
          "description": "Place of onboarding training",
          "title": "Training Venue"
        },
        "upcoming_scheduled_appointment": {
          "description": "Candidate's upcoming scheduled date of interview",
          "title": "Upcoming Scheduled Appointment"
        },
        "virtual_interview_link": {
          "description": "Personalized link to join a live virtual interview session",
          "title": "Virtual Interview Link"
        },
        "voice_ai_phone_call": {
          "description": "Link for the candidate to initiate a voice AI phone call",
          "title": "Voice AI Phone Call"
        },
        "voice_ai_web_call": {
          "description": "Link for the candidate to initiate a voice AI web call",
          "title": "Voice AI Web Call"
        },
        "whatsapp_call_to_action_link": {
          "description": "Whatsapp To Action Link",
          "title": "Whatsapp Call To Action Link"
        },
        "workday_candidate_id": {
          "description": "Candidate ID from Workday",
          "title": "Workday Candidate ID"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Add a Question",
        "create_new": "Create New",
        "delete": "Delete",
        "question_set": {
          "name": "Question Set Name",
          "search": "Search Question Sets",
          "send": "Send Question Set"
        }
      },
      "text": {
        "created_by": "Created by %{name} on %{date}",
        "edited_by": "Edited by %{name} on %{date}",
        "question_set": {
          "cannot_be_deleted": "This Question Set cannot be deleted as it's being used by Autoflow in the following campaigns",
          "description": "Configure sets of questions from Question Templates to be used in Autoflow to trigger Follow up Question to Leads at any point of the process. ",
          "name_description": "This name will help you identify your Question Set when configuring an Autoflow. We recommend that you make it unique and easy to identify.",
          "restricted_prompts": "Only Audio questions are shown because this set is used in a Voice AI Assistant",
          "smart_call_settings": "This Question Set only supports Audio questions because it's used in Voice AI Assistants",
          "title": "Question Sets",
          "used_in_campaigns": "This Question Set cannot be deleted as it's being used in the following Campaigns"
        }
      }
    },
    "smart_call": {
      "landing_page": {
        "label": {
          "agent": "%{agent} is about to call you",
          "from": "from %{number}",
          "get_ready": "Get Ready!",
          "greetings": "Hello %{name}",
          "retrigger": {
            "button": "Start the Interview Now",
            "title": "If the call doesn't start within 2 minutes, click the button below to trigger it manually"
          },
          "tips": {
            "heads_up": "📝 Be ready to talk about your experience and answer a few questions.",
            "place": "📞 Stay in a quiet place where you can focus without distractions.",
            "signal": "🌐 Ensure you have a strong phone signal for a smooth call.",
            "time": "⏰ Have at least 10 minutes available to complete the call.",
            "title": "Quick Tips"
          }
        }
      },
      "setting": {
        "add": "Add new Voice AI",
        "ai_agents": "AI Agents",
        "ai_agents_add": "New Agent",
        "ai_agents_description": "Integrate AI Agents with Autoflow to automate calls, creating engaging experiences that enhance every touchpoint with your talent.",
        "create": {
          "action": "Create Agent",
          "click_here": "Click here",
          "click_here_url": "https://help.talkpush.com/en",
          "description": "Please enter the ID of the Voice AI configuration you wish to integrate with Talkpush.",
          "error": "Oops! Something went wrong. Please try again.",
          "example": "e.g., S1R2wOIovQnibnzRk8hCF7w",
          "identifier": "Voice AI ID",
          "learn_more": "to learn how to find your Voice AI ID",
          "title": "Create your agent"
        },
        "description": "Integrate Voice AI with Autoflow to automate calls, creating engaging experiences that enhance every touchpoint with your talent.",
        "edit": {
          "form": {
            "ai_agent_configuration": {
              "description": "Configure the Voice AI settings",
              "title": "Voice AI Configuration"
            },
            "ai_agent_details": {
              "add_voice_sample": "Add Voice Sample",
              "audio_file": "Audio file (MP3), up to 5MB",
              "click_to_upload": "Click to upload or drag and drop",
              "description": "Configure the Voice AI details",
              "title": "Voice AI Details"
            },
            "audio_file_upload": {
              "description": "Upload an audio file for this Voice AI",
              "title": "Audio File"
            },
            "available_prompt_sets": "Only sets with audio-only questions can be selected",
            "cancel": "Cancel",
            "candidate_attribute": "Select Candidate Attribute",
            "drag_drop_audio": "Drag and drop an audio file here, or click to select",
            "drop_audio_here": "Drop audio file here",
            "extracted_data_configuration": {
              "description": "Map the extracted data to candidate attributes",
              "title": "Extracted Data Configuration"
            },
            "prompt_set": "Select a Question Set",
            "save": "Save",
            "supported_formats": "Supported formats MP3, WAV, M4A, OGG (Max 50MB)",
            "uploading_audio": "Uploading audio file...",
            "value": "Enter Value"
          },
          "input": {
            "description": "Complete the form below to customize the details your Voice AI will use during the call",
            "title": "Voice AI Configuration"
          },
          "language": "Language",
          "output": {
            "description": "Please map each piece of extracted information to the corresponding candidate attribute where it should be stored.",
            "title": "Map Extracted Data to Candidate Attributes"
          },
          "persona": "Persona",
          "sync": "CHECK FOR UPDATES",
          "sync_description": "Use this function to synchronize any changes made to your Voice AI configuration on the original platform, such as updates to voice, language, scenarios, or data fields to collect.",
          "sync_modal": {
            "button": "SYNC NOW",
            "description": "Are you sure you want to synchronize the Voice AI configuration with the latest updates from the original platform? This action will overwrite any changes made in Talkpush.",
            "title": "Sync Voice AI configuration"
          },
          "title": "Edit Voice AI Configuration",
          "toaster": {
            "error": "Oops! Something went wrong. Please try again.",
            "sync": "Voice AI configuration synchronized successfully.",
            "update": "Voice AI call configuration updated successfully."
          }
        },
        "input": {
          "application_status": {
            "description": "Current status of the application.",
            "name": "Application Status"
          },
          "available_interview_dates": {
            "description": "List of dates available for interviews.",
            "name": "Available Interview Dates"
          },
          "available_interview_times": {
            "description": "List of times available for interviews.",
            "name": "Available Interview Times"
          },
          "benefits_info": {
            "description": "Summary of benefits offered.",
            "name": "Benefits Info"
          },
          "call_to_action": {
            "description": "Suggested next steps for the candidate.",
            "name": "Call to Action"
          },
          "company_updates": {
            "description": "Recent news or open positions.",
            "name": "Company Updates"
          },
          "contact_details": {
            "description": "How the candidate can reach out.",
            "name": "Contact Details"
          },
          "contact_email": {
            "description": "Email of the contact person.",
            "name": "Contact Email"
          },
          "contact_info": {
            "description": "Contact details for questions.",
            "name": "Contact Info"
          },
          "contact_person": {
            "description": "Name of the event contact.",
            "name": "Contact Person"
          },
          "contact_phone_number": {
            "description": "Phone number of the contact person.",
            "name": "Contact Phone Number"
          },
          "documents_required": {
            "description": "List of needed documents.",
            "name": "Documents Required"
          },
          "event_date": {
            "description": "Date of the event.",
            "name": "Event Date"
          },
          "event_description": {
            "description": "Brief details about the event.",
            "name": "Event Description"
          },
          "event_location": {
            "description": "Venue or access details.",
            "name": "Event Location"
          },
          "event_name": {
            "description": "Name of the event.",
            "name": "Event Name"
          },
          "event_reference": {
            "description": "The specific event or process to provide feedback on.",
            "name": "Event Reference"
          },
          "event_time": {
            "description": "Time of the event.",
            "name": "Event Time"
          },
          "feedback_provided": {
            "description": "Optional feedback for the candidate.",
            "name": "Feedback Provided"
          },
          "feedback_questions": {
            "description": "List of questions for feedback.",
            "name": "Feedback Questions"
          },
          "first_day_schedule": {
            "description": "Agenda for the first day.",
            "name": "First Day Schedule"
          },
          "future_opportunities_info": {
            "description": "Information about future openings.",
            "name": "Future Opportunities Info"
          },
          "incentive_details": {
            "description": "Information about any incentives (optional).",
            "name": "Incentive Details"
          },
          "information": {
            "description": "Any information that should be asked by Sam during the call.",
            "name": "Information"
          },
          "interview_location": {
            "description": "The address or venue where the interview will take place.",
            "name": "Interview Location"
          },
          "interview_questions": {
            "description": "List of questions to ask.",
            "name": "Interview Questions"
          },
          "interviewer_names": {
            "description": "Names of the interviewers.",
            "name": "Interviewer Names"
          },
          "next_steps": {
            "description": "What the candidate should expect next.",
            "name": "Next Steps"
          },
          "onboarding_location": {
            "description": "Venue for onboarding activities.",
            "name": "Onboarding Location"
          },
          "position_applied_for": {
            "description": "The job position the candidate applied for.",
            "name": "Position Applied For"
          },
          "position_title": {
            "description": "The title of the job position.",
            "name": "Position Title"
          },
          "purpose": {
            "description": "The personalized call goal.",
            "name": "Purpose"
          },
          "rejection_reason": {
            "description": "Optional reason for rejection.",
            "name": "Rejection Reason"
          },
          "special_instructions": {
            "description": "Additional information for the candidate.",
            "name": "Special Instructions"
          },
          "start_date": {
            "description": "Proposed start date for the position.",
            "name": "Start Date"
          },
          "start_time": {
            "description": "Additional information about the status.",
            "name": "Start Time"
          },
          "status_details": {
            "description": "Additional information about the status.",
            "name": "Status Details"
          },
          "submission_deadline": {
            "description": "Date by which documents should be submitted.",
            "name": "Submission Deadline"
          },
          "submission_method": {
            "description": "How to submit the documents.",
            "name": "Submission Method"
          }
        },
        "learn_more_url": "https://help.talkpush.com/en/articles/10258659-voice-ai-the-ai-recruiter-that-calls-candidates-and-collects-info-through-talkpush",
        "no_category": "No category",
        "pending_configuration": "Pending Configuration",
        "phone_calls": "Phone Calls",
        "scenario": {
          "custom_calls": "Tailored call types that you can customize to meet specific business needs, allowing for unique interactions that align with your recruitment strategies and company culture.",
          "document_request": "Calls requesting additional documents or information needed to advance their application, such as portfolios, certifications, or references, facilitating a complete evaluation.",
          "engagement_calls_for_passive_candidates": "Proactive calls aimed at nurturing relationships with passive candidates by informing them about new opportunities, company updates, or industry insights to keep them interested.",
          "feedback_collection": "Calls designed to gather feedback from candidates about their recruitment experience, providing valuable insights to improve your hiring process.",
          "interview": "Structured calls using predefined, consistent interview questions to efficiently assess candidate qualifications while ensuring fairness and compliance.",
          "job_fair_and_event_invitation": "Engaging calls that invite candidates to upcoming recruitment events, webinars, or job fairs, highlighting the benefits of attendance and encouraging participation.",
          "offer_extension": "Exciting calls to extend a job offer, outlining key details like salary, benefits, start date, and next steps, making the candidate feel valued and informed.",
          "on_site_interview_invitation": "Personalized calls inviting candidates to schedule an in-person interview, confirming appointment details, and providing essential logistical information to ensure a smooth experience.",
          "onboarding_information": "Informative calls providing new hires with essential onboarding details, including first-day instructions, required paperwork, and orientation schedules to ensure a seamless transition.",
          "rejection_notification": "Respectful calls to inform candidates that they were not selected, offering closure and potentially brief feedback to maintain a positive employer brand.",
          "reminder": "Automated calls reminding candidates of upcoming interviews, assessments, or deadlines for document submissions to keep the recruitment process on track.",
          "status_update": "Regular calls providing candidates with updates on their application status, ensuring they are informed about their progress and next steps in the recruitment process."
        },
        "subtitle": "A smart voice solution that talks to job candidates in real time.",
        "talkscore_ai_interview": "TalkScore AI Interview",
        "title": "Voice AI Calls"
      },
      "web_call": {
        "audio_devices": {
          "microphone": {
            "errors": {
              "no_microphone_selected": "No microphone selected",
              "no_microphones_available": "No microphones found"
            },
            "name": "Microphone"
          },
          "speaker": {
            "default_system_device_name": "Default System Speaker",
            "errors": {
              "no_speaker_selected": "No speaker selected",
              "no_speakers_available": "No speakers found"
            },
            "name": "Speaker"
          }
        },
        "branding": {
          "powered_by": "Powered by"
        },
        "call_agent": {
          "mode": {
            "idle": "Idle",
            "listening": "Listening",
            "speaking": "Speaking"
          }
        },
        "call_feedback_screen": {
          "actions": {
            "submit": {
              "feedback": {
                "error": "Failed to submit feedback. Please try again.",
                "success": "Thank you for your feedback!"
              },
              "title": "Submit feedback"
            }
          },
          "comments": {
            "description": "Feedback, praise, bugs - we're all ears!",
            "label": "Anything we can do better?"
          },
          "message": "Our recruitment team will review your responses and be in touch shortly.",
          "rating": {
            "label": "Rate your experience"
          },
          "title": "You're all set!"
        },
        "call_screen": {
          "audio_settings": {
            "microphone_volume_indicator": "Input Level",
            "output_volume_control": "Output Volume"
          },
          "call_controls": {
            "audio_settings": "Audio settings",
            "end_call": "End call",
            "mute_microphone": "Mute microphone",
            "unmute_microphone": "Unmute microphone"
          },
          "call_info": {
            "popover_anchor_label": "Information about recording"
          },
          "loading": {
            "title": "%{agent_name} is preparing for your interview.\nThis will just take a moment...\n"
          },
          "network_connection_indicator": {
            "description": {
              "disconnected": "You lost your network connection. Trying to reconnect.",
              "good": "Good connection. You're all set!",
              "unknown": "This browser does not support network monitoring.",
              "unstable": "Poor connection. Try moving closer to your router."
            },
            "popover_anchor_label": "Network connection status"
          }
        },
        "call_setup_screen": {
          "actions": {
            "setup_audio_devices": {
              "title": "Continue"
            },
            "start_call": {
              "feedback": {
                "error": "We couldn't start your interview. Please try again."
              },
              "title": "Start Interview"
            }
          },
          "audio_setup": {
            "description": "Let's make sure we can hear each other clearly before starting.",
            "errors": {
              "denied_microphone_access": {
                "description": "We couldn't detect your microphone. Please connect a microphone or check your browser permissions to continue.",
                "title": "Mic Blocked"
              },
              "no_microphone_available": {
                "description": "No microphone was detected. Please connect a microphone to continue with the interview.",
                "title": "No Microphone Available"
              }
            },
            "test": "Test",
            "title": "Check your audio setup"
          },
          "call_details": {
            "data_access_terms": {
              "description": "This interview helps us better understand your experience.",
              "title": "Reviewed by our team"
            },
            "duration": {
              "description": "You'll answer a few questions at your own pace. There are no right or wrong answers; just respond naturally.",
              "title": "Short, guided conversation"
            },
            "media_requirements": {
              "description": "No camera is required; just make sure you're in a quiet place.",
              "title": "Audio only"
            }
          },
          "description": "You'll answer a few questions about your experience and how you'd handle real-world scenarios.",
          "devices_access_denied_modal": {
            "disclaimer": "The microphone permission allows us to list the microphones and speakers connected to your device",
            "instructions": {
              "step_1": {
                "prefix": "1. Click the",
                "suffix": "icon in your browser address bar"
              },
              "step_2": "2. Grant permission to your microphone to continue."
            },
            "title": "Allow microphone access"
          },
          "greeting": "Let's get ready for your interview!"
        },
        "disclaimers": {
          "recording_notice": "This session will be recorded for assessment and quality purposes."
        },
        "load_error_screen": {
          "actions": {
            "contact_support": {
              "email_template": {
                "body": "Hello,\n\nI'm experiencing issues initiating my interview call.\n\nCompany: %{company}\nInterview Call ID: %{call_id}\n\nPlease assist me with this issue.\n\nThank you.\n",
                "subject": "I'm unable to start my interview call"
              },
              "title": "Contact our team"
            },
            "retry_load": {
              "title": "Try again"
            }
          },
          "first_attempt": {
            "message": "Something went wrong while setting up your interview. Don't worry your application is safe. Let's try again.",
            "title": "We couldn't load your interview"
          },
          "second_attempt": {
            "message": "We're unable to load your interview. Your application is safe. Please try again in a few minutes or contact our recruitment team.",
            "title": "Can't connect right now"
          }
        },
        "loading_screen": {
          "title": "Setting up your interview"
        }
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "helpers": {
    "nav": {
      "campaigns": "Campaigns"
    },
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "onboarding_title": "Onboarding Questions",
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    },
    "update": "Update"
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "minute": "1 minute",
    "minutes": "%{minutes} minutes",
    "pm": "PM",
    "second": "1 second",
    "seconds": "%{seconds} seconds",
    "time_left": "Time Left: %{minutes} %{seconds}"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
